/**
 * @generated SignedSource<<1a19f6adc06b7d999e551ea9d4aec01f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleStorytellingWrapper_storytellingModule$data = {
  readonly storytellingModules: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleStorytellingCard_storytellingModule">;
  } | null> | null;
  readonly " $fragmentType": "SbSharedContentModuleStorytellingWrapper_storytellingModule";
};
export type SbSharedContentModuleStorytellingWrapper_storytellingModule$key = {
  readonly " $data"?: SbSharedContentModuleStorytellingWrapper_storytellingModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleStorytellingWrapper_storytellingModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleStorytellingWrapper_storytellingModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorytellingModuleItem",
      "kind": "LinkedField",
      "name": "storytellingModules",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleStorytellingCard_storytellingModule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentModuleStorytelling",
  "abstractKey": null
};

(node as any).hash = "04f68d3d38c48d9c5ad77eed452a60c1";

export default node;
